import { Link } from "react-router-dom";
import AlertSignup from "@/components/content/AlertSignup";

export const AFFILIATE_DISCLOSURE =
  "Some links on PeptideX may be partner links. If you sign up through one, we may earn a fee at no extra cost to you. It never changes what we write.";

/** Partner CTA block. No partner programs are approved yet, so it offers the email alert signup. */
export default function PartnerCta({ source }: { source: string }) {
  return (
    <section className="terminal-card p-5 my-8" aria-label="Next step">
      <h2 className="text-lg font-bold text-foreground mb-2">Want to know when prices or approvals change?</h2>
      <p className="mb-4">We email you when the FDA approves a drug, a price changes, or a new option becomes available. Every email links the official source.</p>
      <AlertSignup variant="inline" source={`peptidex-${source}`} peptide={source} headline="Get price and approval alerts" description="Free. No spam. Unsubscribe anytime." />
      <p className="text-xs text-muted-foreground mt-4">
        {AFFILIATE_DISCLOSURE} <Link to="/disclosures" className="text-primary hover:underline">How we make money</Link>.
      </p>
    </section>
  );
}

const HUMECARE_URL = "https://track.revoffers.com/aff_c?offer_id=1588&aff_id=14123";
export const HUMECARE_LINE = "HumeCare+ is an online weight-care program. You can check whether it is a fit for you.";
export const HUMECARE_BUTTON = "See HumeCare+ options";
export const GLP1_COST_DISCLOSURE = "Disclosure: PeptideX may earn a commission if you sign up through the partner link below.";
export const ONLINE_PROGRAM_DISCLOSURE = "Disclosure: PeptideX may earn a commission if you sign up through the partner link below. It does not change this checklist.";

/** HumeCare+ partner block (Katalys program 1588). Disclosure sits directly above; block is labelled "Partner". */
export function HumeCareCta({ source, disclosure, affSub, abTest, variant }: { source: string; disclosure: string; affSub?: string; abTest?: string; variant?: string }) {
  const sub = affSub ?? `peptidex_${source.replace(/-/g, "")}`;
  const href = `${HUMECARE_URL}&aff_sub=${sub}${variant ? `&aff_sub2=${variant.toLowerCase()}` : ""}`;
  const onClick = () => {
    const g = (window as unknown as { gtag?: (...a: unknown[]) => void }).gtag;
    if (typeof g === "function") g("event", "partner_click", { partner: "humecare", source, ...(abTest ? { test_name: abTest, variant } : {}) });
  };
  return (
    <div className="my-8">
      <p className="text-xs text-muted-foreground mb-2">{disclosure}</p>
      <section className="terminal-card p-5" aria-label="Partner">
        <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-muted-foreground mb-2">Partner</p>
        <p className="mb-4">{HUMECARE_LINE}</p>
        <a href={href} target="_blank" rel="sponsored nofollow noopener noreferrer" onClick={onClick}
          className="inline-block rounded-md bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground hover:opacity-90">
          {HUMECARE_BUTTON}
        </a>
        <p className="text-xs text-muted-foreground mt-4"><Link to="/disclosures" className="text-primary hover:underline">How we make money</Link></p>
      </section>
    </div>
  );
}
